import React, { useEffect, useState, useRef } from "react";
import { styled } from '@mui/material/styles';
import Primarytheme from './theme';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ShareIcon from '@mui/icons-material/Share';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from "@mui/material/Tooltip";
import Fade from "@mui/material/Fade";
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Snackbar from "@mui/material/Snackbar";
import LinearProgress from '@mui/material/LinearProgress';

import TimelineIcon from '@mui/icons-material/Timeline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DescriptionIcon from '@mui/icons-material/Description';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { Download, PictureAsPdf } from "@mui/icons-material";

import Timer from "./Timer";
import AlertDialog from './AlertDialog';
import AttentionBlock from './AttentionBlock';
import PreviewBlock from "./PreviewBlock";


import statiRiconosciuti from '../helpers/statiRiconosciuti';
import { getFileFromS3 } from '../helpers/operations';
import renderCellExpand from "../helpers/renderCellExpand";

import axios from 'axios';
import path from 'path';


const {
    REACT_APP_APPURL,
    REACT_APP_X_API_KEY,
    REACT_APP_USER_ID,
    REACT_APP_invokeUrl,
} = process.env;



// STILI
const pickColor = (status, errors) => {
    if (errors && errors.length) return Primarytheme.palette.error.main
    if (statiRiconosciuti.completati.has(status)) return Primarytheme.palette.secondary.main
    if (statiRiconosciuti.falliti.has(status)) return Primarytheme.palette.error.main
    if (status === 'del') return Primarytheme.palette.neutral.light
    else return Primarytheme.palette.primary.main
}

const pickPdfColor = (status) => {
    if (status === 'pagination complete') {
        return Primarytheme.palette.neutral.dark
    } else {
        return Primarytheme.palette.neutral.light
    }
}


const intervalFetch = 10000; //[ms]
const fadeTime = '500'; //[ms]


const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.20),
    marginLeft: 0, marginRight: theme.spacing(0.4),
}));

const typoChipSx = { fontSize: 13, whiteSpace: 'normal', mt: '0.1em', mb: '0.1em' };
const chipSx = { variant: "outlined", size: "small", sx: { height: '100%' } };

export default function RequestBlockSquare({ requestParent, changeItem, user, attached_projects }) {

    // Stato
    const [request, setRequest] = useState(requestParent);
    const [progressState, setProgressState] = useState({ remainingEstimated: requestParent.eta, progress: 0 });

    const [validationErrors, setValidationErrors] = useState({ errors: [], warnings: [] });

    const [expanded, setExpanded] = React.useState(false);

    const [refetch, setRefetch] = useState(0);

    const [deleting, setDeleting] = useState(false);

    const [fadeState, setFadeState] = useState(true);

    // snackbar Share
    const [snack, setSnack] = useState({
        open: false,
        message: 'Url copied to clipboard!'
    })

    // Ref
    const refCard = useRef(null);

    // Metodi
    const handleShareBlock = () => {
        navigator.clipboard.writeText(`${REACT_APP_APPURL}/history/?reqid=${requestParent.reqId}&dateStart=${requestParent.startTime - 120000}&dateEnd=${requestParent.paginationEndTime + 60000}`);
        setSnack({
            open: true,
            message: `url copied to cliboard!`
        })
    }

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnack({ open: false, launchMessage: '' });
    };

    const handleStopProcess = async ({ reqId, project_id }) => {
        //console.log('stop process: ', reqId);
        setDeleting(true);
        axios.delete(REACT_APP_invokeUrl + '/operations' || user.ssmParams.invokeUrl + '/operations', {
            headers: {
                "x-api-key": REACT_APP_X_API_KEY || user.ssmParams.X_API_KEY,
                reqId,
                project_id,
                bucket: request.bucket,
                user_id: 'web-app'
            }
        })
            .then(response => {
                console.log('stop response', response.data);
                fetchDynamoReqId({ force: true });
            }).catch(err => console.log(err))

    }

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleJumpS3Out = () => {
        window.open(`https://s3.console.aws.amazon.com/s3/buckets/${request.bucket}?region=eu-west-1&prefix=${request.project_id}/output/${request.reqId}/`);
    }
    const handleJumpS3Split = () => {
        window.open(`https://s3.console.aws.amazon.com/s3/buckets/${request.bucket}?region=eu-west-1&prefix=split/${request.project_id}/data-webapp/${request.reqId}/`);
    }

    const handleKibanaLog = () => {
        window.open(`http://dragon.pagination.com:5601/app/kibana#/discover/ab1735b0-ba02-11ee-ae3b-7de6523212fb?_g=(filters:!(),refreshInterval:(pause:!t,value:5000),time:(from:now-15m,to:now))&_a=(columns:!(type,payload.sourcedata,'@reqid','@instance'),filters:!(('$state':(store:appState),meta:(alias:types,disabled:!t,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:type.keyword,negate:!f,params:!(pagination-complete,data-integration-response,script-error,runner-error,job-complete,request-received,specific-error,end-split-statistic),type:phrases,value:'pagination-complete,%20data-integration-response,%20script-error,%20runner-error,%20job-complete,%20request-received,%20specific-error,%20end-split-statistic'),query:(bool:(minimum_should_match:1,should:!((match_phrase:(type.keyword:pagination-complete)),(match_phrase:(type.keyword:data-integration-response)),(match_phrase:(type.keyword:script-error)),(match_phrase:(type.keyword:runner-error)),(match_phrase:(type.keyword:job-complete)),(match_phrase:(type.keyword:request-received)),(match_phrase:(type.keyword:specific-error)),(match_phrase:(type.keyword:end-split-statistic)))))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:'@reqid.keyword',negate:!t,params:(query:vscode),type:phrase,value:vscode),query:(match:('@reqid.keyword':(query:vscode,type:phrase)))),('$state':(store:appState),meta:(alias:'errors%20only',disabled:!t,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:'@level',negate:!f,params:(query:'5'),type:phrase,value:'5'),query:(match:('@level':(query:'5',type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:tags,negate:!t,params:(query:ids-log),type:phrase,value:ids-log),query:(match:(tags:(query:ids-log,type:phrase)))),('$state':(store:appState),meta:(alias:!n,disabled:!f,index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',key:'@reqid',negate:!f,params:(query:'${request.reqId}'),type:phrase,value:'${request.reqId}'),query:(match:('@reqid':(query:'${request.reqId}',type:phrase))))),index:'9339ec40-ac87-11e9-ae3b-7de6523212fb',interval:auto,query:(language:kuery,query:''),sort:!('@timestamp',desc))`);
    }

    const handleMakePublic = () => {
        setDeleting(true);
        axios({
            method: "patch",
            url: 'https://api.pagination.com/vpc/projects-webapp',
            headers: {
                "reqid": request.reqId,
                "project_id": request.project_id,
                "content-type": "application/json",
                "x-api-key": REACT_APP_X_API_KEY || user.ssmParams.X_API_KEY,
            },
            data: {
                internalTest: false
            }
        })
            .then(resp => fetchDynamoReqId({ force: true, type: 'patch' }))
            .then(() => setDeleting(false))
            .catch(err => {
                console.log(err)
            })
    }


    const handleValidationErrors = () => {

        const validationObj = { ...validationErrors };
        let flag_ChangeState = false;
        if ((statiRiconosciuti.falliti.has(request.status) || validationErrors.errors.length === 0) && request.errors) {
            validationObj.errors.push(...request.errors);
            flag_ChangeState = true;
        }
        if ((statiRiconosciuti.terminati.has(request.status) || statiRiconosciuti.running.has(request.status)) &&
            validationErrors.warnings.length === 0 && request.warnings) {
            validationObj.warnings.push(...request.warnings);
            flag_ChangeState = true;
        }

        if (flag_ChangeState) setValidationErrors({ ...validationObj })
    }

    const fetchDynamoReqId = ({ force = false, type }) => {

        if (force || statiRiconosciuti.running.has(requestParent.status)) {
            //console.log('refresh reqid')
            axios({
                method: "get",
                url: 'https://api.pagination.com/vpc/operations',
                headers: {
                    'user_id': REACT_APP_USER_ID || user.ssmParams.USER_ID,
                    "content-type": "application/json",
                    "x-api-key": REACT_APP_X_API_KEY || user.ssmParams.X_API_KEY,
                    "reqId": requestParent.reqId,
                    "project_id": requestParent.project_id,

                    // non usati, ma expected dalla lambda
                    "project_ids": requestParent.project_id,
                    "stati": 'tutti',
                }
            })
                .then(resp => {
                    //console.log('fetched single ', requestParent.reqId, resp.data);
                    if (type === 'patch') {
                        setRequest(resp.data);
                    }
                    else if (!resp.data || resp.data === '') {
                        resp.data = { ...requestParent };
                        resp.data.delete = 'delete';
                        setRequest(resp.data);
                        setFadeState(false);

                    }
                    else if (resp.data && resp.data.deleted) {
                        resp.data = { ...requestParent };
                        resp.data.delete = 'delete';
                        setRequest(resp.data);
                        setFadeState(false);

                    }
                    else if (statiRiconosciuti.completati.has(resp.data.status) || statiRiconosciuti.falliti.has(resp.data.status)) {
                        setRequest(resp.data);
                        setFadeState(false);
                    }
                    else {
                        //console.log('still running ', resp.data.reqId )
                        setRequest(resp.data);
                        setRefetch(refetch => refetch + 1);
                    }
                })
                .catch(err => console.log(err))
        }

    }


    // fade in on mont, fade out on unmount
    useEffect(() => {
        if (requestParent.moved) {
            setFadeState(true);
        }
    }, [requestParent.moved]);

    useEffect(() => {
        if (fadeState === false) {
            //console.log('on fade state change, false, change item')
            setTimeout(() => {
                //console.log('chiamo change item')
                changeItem({ reqId: request.reqId, newItem: request });
                //setFadeState(true);
            }, fadeTime)
        }

    }, [fadeState])

    // Recompute Progress and estimated, retrieve first tumbnails
    useEffect(() => {
        // compute progress
        const { progress, etaRealistico } = getProgress(request)
        const remaining____ = etaRealistico - (etaRealistico * progress / 100); // [ms]
        setProgressState({ remainingEstimated: remaining____, progress });

        // build table for errors and warnings data int
        handleValidationErrors();
    }, [requestParent.reqId, requestParent.version, refetch]);



    // GESTIONE AUTO FETCH DYNAMO SINGOLO BLOCCO
    const setIntervalFetch = () => {
        const interval = setInterval(
            () => fetchDynamoReqId({ force: false }),
            intervalFetch
        );
        return interval
    }

    useEffect(() => {
        if (statiRiconosciuti.running.has(requestParent.status)) {
            //console.log('effetto refetch timer')
            const interval = setIntervalFetch();
            return () => {
                clearInterval(interval);
                // console.log('effetto pulito')
            }
        }
    }, [requestParent.status]);


    // reference https://docs.google.com/document/d/19ukwod5_190v6j2TKXAEPDvoZfGpksFVWdDfiqSGqRI/edit
    const statusMessage = buildStatusMessage(request);


    return (
        <Fade timeout={1500} in={fadeState} >
            <Card ref={refCard} sx={{ minHeight: '12em', borderTop: 5, borderColor: pickColor(deleting ? 'del' : request.status, request.errors), width: '100%' }}>
                < CardContent sx={{ padding: '0.5em' }} >

                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1} >
                        <Stack direction='column' spacing={1} sx={{ width: '85%' }}>
                            <Typography sx={{ fontSize: 14, wordWrap: 'break-word' }} gutterBottom>
                                <b>{request.flagOverrideTitle ? request.flagOverrideTitle : (request.origin ? request.origin.split('/').pop() : '')}</b>
                            </Typography>
                            <Box component='ul' sx={{
                                display: 'flex',
                                justifyContent: 'left',
                                flexWrap: 'wrap',
                                listStyle: 'none',
                                p: 0,
                                m: 0,
                            }}>
                                {user.isAdmin && <ListItem><Chip label={<Typography sx={typoChipSx}>{request.project_id}</Typography>}  {...chipSx} />  </ListItem>}
                                {!user.isAdmin && attached_projects.length > 1 && <ListItem><Chip label={<Typography sx={typoChipSx}>{request.project_id.split('/').pop()}</Typography>}  {...chipSx} />  </ListItem>}
                                {request.tag && <ListItem><Chip label={<Typography sx={typoChipSx}>{request.tag}</Typography>} {...chipSx} />  </ListItem>}

                                {/*                         {request.tagsObj && (
                            request.tagsObj.map(tagPair => (
                                <ListItem key={tagPair.name}><Chip label={tagPair.value} variant="outlined" size="small" />  </ListItem>
                            ))
                        )} */}
                                {request.internalTest && <ListItem><Chip label='internal test' variant="outlined" size="small" color='warning' onDelete={() => handleMakePublic()} />  </ListItem>}
                                {request.doOnlyValidation && <ListItem><Chip label='data integration only' variant="outlined" size="small" color='info' />  </ListItem>}
                            </Box>

                            <Typography variant='caption' color='textSecondary' component='div' mt='0.5em'>
                                {(new Date(request.startTime)).toLocaleString()}
                            </Typography>

                        </Stack>
                        <Stack direction='column' spacing={0} >
                            <Tooltip title="share link to this export">
                                <IconButton sx={{ color: Primarytheme.palette.neutral.dark }} aria-label="Share request URL" onClick={handleShareBlock} size='small' >
                                    <ShareIcon fontSize='small' />
                                </IconButton>
                            </Tooltip>

                            {user.isAdmin && (
                                <Tooltip title="Output folder in S3">
                                    <IconButton onClick={handleJumpS3Out} size='small'>
                                        <OpenInNewIcon fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {user.isAdmin && (
                                <Tooltip title="Split folder in S3">
                                    <IconButton onClick={handleJumpS3Split} size='small'>
                                        <AccountTreeIcon fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            )}
                            {user.isAdmin && (
                                <Tooltip title="Kibana">
                                    <IconButton onClick={handleKibanaLog} size='small'>
                                        <TimelineIcon fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            )}
                        </Stack>
                    </Stack>
                </CardContent >
                {/* <MainCardObject request={request} progressState={progressState.progress} props={{ margin: '1em' }} /> */}

                {statiRiconosciuti.running.has(request.status) && (
                    < LinearProgress
                        key={request.reqId}
                        sx={{ mb: '0.5em', color: pickColor(request.status), height: 25 }}
                        variant={!isNaN(progressState.progress) ? "determinate" : 'indeterminate'}
                        value={progressState.progress}
                    />
                )}

                {statiRiconosciuti.completati.has(request.status) && (
                    <PreviewBlock refCard={refCard} thumbs={request.thumbnails} thumbnailsFolder={request.thumbnailsFolder} bucket={request.bucket} status={request.status} mainDownload={request.mainDownload} output={request.output} ssm={user.ssmParams} />
                )}

                {validationErrors.warnings.length > 0 && <AttentionBlock attentions={validationErrors.warnings} color='warning' buttonLabel='Show warnings' title='Validation warnings' />}
                {validationErrors.errors.length > 0 && <AttentionBlock attentions={validationErrors.errors} color='error' buttonLabel='Show errors' title='Validation errors' />}
                {statiRiconosciuti.propriofalliti.has(request.status) && <AttentionBlock buttonLabel='Show errors' color='error' title='Process Error' notes=' An error occurred during the process. Please check that your datafile is not corrupted and that it follows the rules.' />}

                <CardContent sx={{ p: 0, pl: '0.5em', }}>
                    <Timer fetchDynamoReqId={fetchDynamoReqId} remainingEstimated={progressState.remainingEstimated} progress={progressState.progress} ignoreEta={request.ignoreEta}
                        status={request.status} doOnlyValidation={request.doOnlyValidation} startTime={request.startTime} endTime={request.paginationEndTime} />
                </CardContent >

                <CardActions disableSpacing >
                    <Tooltip title="View PDF">
                        <span>
                            <IconButton onClick={() => getFileFromS3({ key: request.mainPdf, bucket: request.bucket, customBucket: request.customBucket, ssmParams: user.ssmParams })} disabled={!request.mainPdf || request.status != "pagination complete"} size="small" sx={{ color: pickPdfColor(request.status), marginRight: '0.5em' }} >
                                < PictureAsPdf />
                            </IconButton>
                        </span>
                    </ Tooltip >
                    <Tooltip title='Download Export'>
                        <span>
                            <IconButton onClick={() => getFileFromS3({ key: request.mainDownload, bucket: request.bucket, customBucket: request.customBucket, attachment: true, ssmParams: user.ssmParams })} disabled={!request.mainDownload || request.status != "pagination complete"} size="small" sx={{ color: pickPdfColor(request.status), marginRight: '0.5em' }} >
                                < Download />
                            </IconButton>
                        </span>
                    </ Tooltip >

                    <Tooltip title="Download Datafile">
                        <IconButton size="small" onClick={() => getFileFromS3({ key: path.join(request.project_id, request.origin), bucket: request.bucket, attachment: true, ssmParams: user.ssmParams })}
                            disabled={request.disableDatafile}
                            sx={{ color: Primarytheme.palette.neutral.dark, marginRight: '0.5em' }} >
                            < DescriptionIcon />
                        </IconButton>
                    </ Tooltip >

                    <Snackbar
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        open={snack.open}
                        autoHideDuration={5000}
                        onClose={handleCloseSnack}
                        message={snack.message}
                        action={
                            <IconButton size="small" color="inherit" onClick={handleCloseSnack}>
                                <CloseIcon />
                            </IconButton>
                        }
                    />

                    {user.policy.canDelete && (
                        <AlertDialog title='Clear the process from history?'
                            text="Clearing the process will stop the ongoing pagination (if it is still running) and it will erase the information about this request from your project' s history."
                            handleActionOnAgree={() => handleStopProcess({ reqId: request.reqId, project_id: request.project_id })}
                            icon={<DeleteIcon />}
                            tip='Clear process'
                        />
                    )}

                    <ExpandMore
                        expand={expanded}
                        onClick={handleExpandClick}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </ExpandMore>

                </CardActions >

                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent>
                        <Typography variant="caption" component={'div'} color="textSecondary" gutterBottom={false}>
                            <b>Status</b>
                        </Typography>
                        {statusMessage && statusMessage.split('\n').map((str, index) => (
                            <Typography key={index} variant="caption" component={'div'} color="textSecondary" gutterBottom={false} >
                                {str}
                            </Typography>
                        ))}

                        {request.pagOpts && request.pagOpts.length > 0 && (
                            <Box mt='0.5em'>
                                <Typography component="div" variant="caption" color="textSecondary"  >
                                    <b>Options</b>
                                </Typography>
                                {request.pagOpts.map(opt => (
                                    <Typography key={opt.name} component="div" variant="caption" color="textSecondary"  >
                                        {opt.name === 'tag' ? 'Process' : opt.name}: {`${opt.value}`}
                                    </Typography>
                                ))
                                }
                            </Box>
                        )}

                        <Box mt='0.5em'>
                            <Typography component="div" variant="caption" color="textSecondary" >
                                <b>Info</b>
                            </Typography>
                            <Typography component="div" variant="caption" color="textSecondary">
                                {request.project_id}
                            </Typography>
                            <Typography component="div" variant="caption" color="textSecondary">
                                {(request.owner && request.owner.user_id) ? request.owner.user_id : request.owner}
                            </Typography>
                            <Typography component="div" variant="caption" color="textSecondary">
                                {request.reqId}
                            </Typography>
                        </Box>
                    </CardContent>
                </Collapse>

            </Card >
        </Fade >
    )
}





const ExpandMore = styled((props) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));



function getProgress({
    eta, ignoreEta = false,
    pesoBook = 1,
    peso_split = 1,
    queuedTime,
    lastQueueTimeStart,
    v_media_split,
    v_media_book,
    tempoTotaleMedioPerRiga,
    splitObj,
    queueTimePerSplitMedio = 5000,
    splitDoneObj, bookDoneObj = [],
    n_split, n_books = 0,
    startTime,
    status } = {}) {

    let progress;
    let etaRealistico = eta;

    switch (status) {
        case 'queued':
            progress = NaN;
            break;
        case 'queued validated':
            progress = 0;
            break;

        case 'pagination failed':
            progress = 0;
            break;

        case 'validation failed':
            progress = 0;
            break;

        case 'pagination complete':
            progress = 100;
            break;

        default:
            const splitDoneKeys = splitDoneObj ? Object.keys(splitDoneObj) : [];
            const bookDoneKeys = bookDoneObj ? Object.keys(bookDoneObj) : [];
            const s_fratcion = splitDoneKeys.length / n_split;
            const book_fraction = n_books > 0 ? bookDoneKeys.length / n_books : 1;
            const generic_fraction = n_books > 0 ? (bookDoneKeys.length + splitDoneKeys.length) / (n_split + n_books) : splitDoneKeys.length / n_split;

            const diffSplit = n_split - splitDoneKeys.length;
            const diffBook = n_books - bookDoneKeys.length;
            const beta = (diffSplit === 0 && n_books > 0 && diffBook === 1) ? 1000 : (4 / (diffSplit + diffBook) + 1);


            // stimo ETA realistico basandomi sugli split ancora da fare
            etaRealistico = eta; // [ms]

            // tempo passato, scevro dal tempo passato in coda e corretto a zero quando in coda
            let t_passato;


            if (status === 'queued (validated)') t_passato = (new Date().getTime() - startTime - (new Date().getTime() - lastQueueTimeStart)); // [ms]
            else if (status === 'pagination in progress - queued') t_passato = (new Date().getTime() - startTime - (new Date().getTime() - lastQueueTimeStart) - queuedTime); // [ms]
            else t_passato = (new Date().getTime() - startTime - queuedTime); // [ms]

            if (!ignoreEta && etaRealistico) {
                const t_fraction = t_passato <= etaRealistico ? t_passato / etaRealistico : 1;
                if (t_fraction === 1 && s_fratcion === 1 && bookDoneKeys.length >= n_books - 1) progress = NaN;
                else progress = 100 * (peso_split * s_fratcion + pesoBook * book_fraction + beta * t_fraction) / (beta + peso_split + pesoBook); // [%]
                //console.log(peso_split, s_fratcion, pesoBook, book_fraction, beta, t_fraction, progress)
            }
            else if (n_split === 1) {
                progress = NaN;
            }
            else {
                progress = 100 * generic_fraction; // [%]
            }


            break;
    }


    return { progress, etaRealistico }
}

function buildStatusMessage({ status, splitDoneObj, n_split, bookDoneObj, n_books }) {
    let statusMessage = '';
    statusMessage += status;

    switch (status) {
        case 'pagination complete':

            break;
        case 'pagination failed':

            break;
        case 'validation failed':

            break;
        case 'queued':
            break;

        case 'nothing to paginate':
            statusMessage += '\nPlease check if the datafile is currupted and if it is compliant to the rules';
            break;


        default:
            if (splitDoneObj) {
                statusMessage += ` - ${Object.keys(splitDoneObj).length} / ${n_split} splits`
            }
            if (bookDoneObj && n_books > 0) {
                statusMessage += ` - ${Object.keys(bookDoneObj).length} / ${n_books} books`

            }
            break;
    }

    return statusMessage
}